import React from "react"

import { useUID } from "utils"

import { labelStyles, textareaStyles, errorStyles } from "./Textarea.styles"

const Textarea = ({ id, label, error, ...rest }) => {
  const generatedId = useUID()
  const inputId = id || generatedId

  return (
    <div data-component="Textarea">
      {label && (
        <label className={labelStyles(error)} htmlFor={inputId}>
          {label}
        </label>
      )}
      <textarea
        aria-invalid={error ? "true" : "false"}
        id={inputId}
        className={textareaStyles(error)}
        {...rest}
      />
      {error && (
        <p role="alert" className={errorStyles}>
          {error}
        </p>
      )}
    </div>
  )
}

export default Textarea
